import createReactComponent from '../createReactComponent';
export default createReactComponent('clock-twelve', 'ClockTwelve', [["path",{"d":"M12 6v6m9 0a9 9 0 1 1-18 0 9 9 0 0 1 18 0","key":"svg-0"}]]);